import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import {
  ComponentRef,
  getComponentRef,
} from "../../message/components/records/MessageTagUtil";

export default function YesNoInput(props) {
  const {
    label,
    id,
    readOnly,
    required,
    onChange,
    yesLabel,
    noLabel,
    //onSaveDraft = () => {},
    value,
    initialValue,
    compactMode = false,
    score,
  } = props;
  const {
    handleSubComponentLoaded = (
      subComponent = { ...ComponentRef },
      isLoaded = false
    ) => {},
  } = props;
  const { itemIndex, level, messageTime } = props;

  const [internalValue, setInternalValue] = useState(value ?? initialValue);

  const questionLabel = useMemo(() => {
    if (!label) {
      return "";
    }

    if (internalValue !== undefined && internalValue !== null && score) {
      /*const actualScore = internalValue ? score.YesScore : score.NoScore;
      return `${label} - ${actualScore}pts`;*/
      return label;
    }

    return label;
  }, [label, internalValue]);

  useEffect(() => {
    if (internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  useEffect(() => {
    handleSubComponentLoaded(
      getComponentRef("YesNoInput", itemIndex, level, messageTime),
      true
    );
  }, []);

  const handleOnChange = (newValue) => {
    if (readOnly) {
      return;
    }
    setInternalValue(newValue);
    onChange(id, newValue);
  };

  if (readOnly) {
    if (internalValue === undefined) {
      return null;
    }

    return (
      <Box>
        <Typography component="span" fontWeight="bold">
          {label}:
        </Typography>
        <Typography component="span" sx={{ ml: 1 }}>
          {internalValue === true && yesLabel}
          {internalValue === false && noLabel}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, pb: compactMode ? 0 : 2 }} id={id}>
      {!compactMode && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Typography variant="subtitle1">{questionLabel}</Typography>
          {required && (
            <Typography
              component="span"
              fontWeight="bold"
              color="error"
              sx={{ ml: 0.5 }}
            >
              *
            </Typography>
          )}
        </Box>
      )}
      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
        <Box sx={{ flex: 1 }}>
          <Button
            type="button"
            sx={{
              width: "100%",
              padding: compactMode ? "4px 8px" : "8px 16px",
              border:
                internalValue === true ? "2px solid #1976d2" : "1px solid #ccc",
              background: internalValue === true ? "#1976d2" : "#fff",
              color: internalValue === true ? "#fff" : "#1976d2",
              cursor: readOnly ? "not-allowed" : "pointer",
              opacity: readOnly ? 0.5 : 1,
              fontWeight: internalValue === true ? "bold" : "normal",
            }}
            disabled={readOnly}
            onClick={() =>
              handleOnChange(
                internalValue === undefined || internalValue === false
                  ? true
                  : undefined
              )
            }
          >
            {yesLabel}
          </Button>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Button
            type="button"
            style={{
              width: "100%",
              padding: compactMode ? "4px 8px" : "8px 16px",
              border:
                internalValue === false
                  ? "2px solid #d32f2f"
                  : "1px solid #ccc",
              background: internalValue === false ? "#d32f2f" : "#fff",
              color: internalValue === false ? "#fff" : "#d32f2f",
              cursor: readOnly ? "not-allowed" : "pointer",
              opacity: readOnly ? 0.5 : 1,
              fontWeight: internalValue === false ? "bold" : "normal",
            }}
            disabled={readOnly}
            onClick={() =>
              handleOnChange(
                internalValue === undefined || internalValue === true
                  ? false
                  : undefined
              )
            }
          >
            {noLabel}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
